var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRecordReady = function SvgRecordReady(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 109,
    viewBox: "0 0 85 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11401_140044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3728 48.0457C35.7249 47.9612 34.0348 49.1232 33.7461 50.7429C33.6263 51.433 33.7461 52.1443 33.9432 52.8204C34.9432 56.2288 37.7883 58.8134 40.894 60.5317C41.0841 60.6373 41.2884 60.743 41.5067 60.75C41.7954 60.757 42.063 60.588 42.2954 60.412C44.9504 58.4683 46.7954 55.4542 47.3307 52.2147C47.4856 51.257 47.5349 50.2499 47.2109 49.3344C46.887 48.4189 46.1475 47.602 45.1968 47.4119C44.3095 47.2358 43.3799 47.6232 42.6968 48.2147C41.5419 49.2218 41.7391 49.7429 40.3517 49.5457C39.4081 49.4119 38.6264 48.1161 37.3658 48.0457H37.3728Z",
    fill: "#DCFF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4652 15.6797C19.3596 41.1376 19.5779 66.6166 19.1272 92.0886C19.1061 93.1239 20.761 92.7224 20.7821 91.8633C21.2328 66.3913 21.0145 40.9122 20.1201 15.4543C20.0849 14.4191 18.437 14.8276 18.4652 15.6797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7332 15.8557C26.6135 41.391 26.4937 66.9264 26.374 92.4618C26.374 93.497 28.0219 93.0956 28.029 92.2365C28.1487 66.7011 28.2684 41.1657 28.3881 15.6303C28.3881 14.5951 26.7402 14.9965 26.7332 15.8557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6057 15.8557C54.2888 41.391 54.2959 66.9264 54.6339 92.4618C54.648 93.497 56.2959 93.0956 56.2888 92.2365C55.9508 66.7011 55.9438 41.1657 56.2607 15.6303C56.2747 14.5951 54.6198 14.9965 54.6057 15.8557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.338 15.4746C63.2535 41.2494 63.1197 67.0454 61.9366 92.8061C61.8873 93.8343 63.5493 93.4329 63.5916 92.5807C64.7747 66.82 64.9085 41.0241 63.993 15.2492C63.9578 14.214 62.3099 14.6225 62.338 15.4746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7321 93.0965C22.1054 93.6739 24.4716 93.7936 26.8871 93.4063C27.8026 93.2584 28.1547 91.7655 27.0209 91.9415C24.8871 92.2795 22.7674 92.2162 20.6617 91.7091C19.8518 91.5119 18.7603 92.857 19.7321 93.0965Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5352 15.8478C21.9648 16.2703 24.4015 16.4816 26.8663 16.4886C27.7254 16.4886 28.5071 15.0168 27.4156 15.0168C24.9508 15.0168 22.5141 14.8055 20.0845 14.3759C19.2183 14.2281 18.4507 15.6576 19.5352 15.8478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1626 16.6385C57.6344 16.7723 60.0851 16.6737 62.5359 16.3286C63.4514 16.1948 63.8105 14.7019 62.6697 14.8638C60.3528 15.1948 58.0429 15.2934 55.7048 15.1667C54.8386 15.1174 54.064 16.5822 55.1555 16.6385H55.1626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3518 93.3282C57.4927 93.4338 59.6265 93.5324 61.7674 93.6381C62.6336 93.6803 63.4082 92.2155 62.3167 92.1662C60.1758 92.0606 58.042 91.962 55.9011 91.8564C55.0349 91.8141 54.2603 93.2789 55.3518 93.3282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9722 20.0539L54.0569 20.2018C54.9161 20.2018 55.6977 18.737 54.6062 18.7299L28.5215 18.582C27.6623 18.582 26.8807 20.0468 27.9722 20.0539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9723 90.3848C36.7892 90.3003 45.6062 90.2088 54.4232 90.1243C55.2753 90.1172 56.057 88.6384 54.9725 88.6524C46.1555 88.737 37.3385 88.8285 28.5216 88.913C27.6695 88.9201 26.8878 90.3989 27.9723 90.3848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7397 23.385L29.5284 38.9977C29.5143 40.033 31.1693 39.6315 31.1833 38.7724L31.3946 23.1596C31.4087 22.1244 29.7538 22.5258 29.7397 23.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2816 23.1933C51.4717 28.3413 51.5915 33.4821 51.6408 38.6301C51.6478 39.6653 53.3027 39.2639 53.2957 38.4047C53.2464 33.2568 53.1267 28.1089 52.9366 22.968C52.9013 21.9328 51.2534 22.3412 51.2816 23.1933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1764 39.9337C37.3455 39.9196 44.5075 39.8562 51.6695 39.7435C52.5216 39.7295 53.3033 38.2506 52.2188 38.2717C45.0568 38.3844 37.8877 38.4478 30.7257 38.4619C29.8736 38.4619 29.0919 39.9337 30.1764 39.9337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5423 23.4906C37.655 23.8991 44.7677 23.9061 51.8804 23.5188C52.8171 23.4695 53.1621 21.9906 52.0142 22.054C45.0353 22.4343 38.0634 22.4202 31.0916 22.0188C30.2254 21.9695 29.4507 23.4273 30.5423 23.4906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8587 51.0666C40.6826 47.8905 35.5347 46.0102 33.6051 49.6018C31.1262 54.2075 37.8868 59.1512 41.1615 61.0737C41.9009 61.5103 43.2178 60.3413 42.408 59.8695C40.0558 58.4892 37.8868 56.7709 36.2178 54.5948C35.4502 53.5948 34.0769 51.5666 34.9079 50.3201C35.4995 49.4328 36.8305 49.0314 37.7953 49.3553C38.9502 49.7427 39.7953 50.4962 40.2249 51.6652C40.5559 52.5666 42.1545 51.8765 41.8587 51.0737V51.0666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.155 51.0895C42.2536 49.1811 43.5846 48.4768 46.1339 48.9909C46.5141 49.7163 46.6761 50.4909 46.6127 51.3078C46.5916 52.3571 46.2958 53.3994 45.9437 54.3783C45.0986 56.7022 43.5986 58.6248 41.6197 60.0966C40.7465 60.7445 41.4507 61.9065 42.3381 61.2445C45.7043 58.7375 49.7607 53.2374 47.9508 48.7444C47.2606 47.0191 45.5846 46.2515 43.8099 46.8078C41.7747 47.4486 40.8592 49.3712 40.5071 51.3219C40.324 52.3149 42.0071 51.9275 42.162 51.0966L42.155 51.0895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3663 43.7717C30.4016 50.3914 30.2114 57.0042 29.7889 63.6169C29.7255 64.6451 31.3875 64.2436 31.4438 63.3915C31.8593 56.7788 32.0565 50.1661 32.0213 43.5463C32.0213 42.5111 30.3663 42.9125 30.3663 43.7717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.253 44.1447C51.3657 50.7574 51.3868 57.3702 51.3164 63.9829C51.3023 65.0181 52.9573 64.6167 52.9713 63.7575C53.0418 57.1448 53.0206 50.5321 52.908 43.9194C52.8939 42.8842 51.2389 43.2856 51.253 44.1447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9153 64.5453C37.8379 64.9186 44.7605 65.0031 51.6971 64.82C52.6338 64.7918 52.9718 63.327 51.8309 63.3552C45.0351 63.5383 38.2534 63.4397 31.4646 63.0735C30.5984 63.0242 29.8237 64.489 30.9153 64.5453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4857 44.2236C38.1548 43.9349 44.8168 43.9208 51.4858 44.1814C52.345 44.2166 53.1267 42.7518 52.0351 42.7095C45.2252 42.449 38.4224 42.4701 31.6195 42.7588C30.6829 42.8011 30.3449 44.2729 31.4857 44.2236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5494 69.8918C37.5917 69.758 44.634 69.6313 51.6763 69.4975C52.5285 69.4834 53.3102 68.0045 52.2256 68.0256C45.1833 68.1594 38.141 68.2862 31.0987 68.42C30.2466 68.4341 29.4649 69.913 30.5494 69.8918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9156 86.6021C37.972 86.5669 45.0214 86.4542 52.0707 86.264C53.0073 86.2359 53.3454 84.7711 52.2045 84.7992C45.289 84.9894 38.3805 85.095 31.4649 85.1302C30.6128 85.1302 29.8311 86.6091 30.9156 86.6021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9786 70.0471L30.2392 85.6598C30.2533 86.6951 31.9082 86.2937 31.8941 85.4345L31.6335 69.8217C31.6195 68.7865 29.9645 69.1879 29.9786 70.0471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0783 69.3136C50.8881 74.7784 51.0008 80.2221 51.4022 85.6729C51.4726 86.6025 53.0994 85.9334 53.036 85.0813C52.6417 79.7503 52.5501 74.4263 52.7332 69.0883C52.7684 68.0601 51.1135 68.4545 51.0783 69.3136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9934 19.2287L22.0145 22.6935C23.0356 22.6231 24.0568 22.5527 25.0779 22.4823C25.2047 21.4118 25.1554 20.3132 24.9371 19.2569C23.9511 19.1865 22.9652 19.2006 21.9863 19.2992",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9934 19.2287L22.0145 22.6935C23.0356 22.6231 24.0568 22.5527 25.0779 22.4823C25.2047 21.4118 25.1554 20.3132 24.9371 19.2569C23.9511 19.1865 22.9652 19.2006 21.9863 19.2992",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4367 69.9475L22.4579 73.4123C23.479 73.3419 24.5001 73.2715 25.5213 73.201C25.648 72.1306 25.5987 71.032 25.3804 69.9757C24.3945 69.9052 23.4086 69.9193 22.4297 70.0179",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4367 69.9475L22.4579 73.4123C23.479 73.3419 24.5001 73.2715 25.5213 73.201C25.648 72.1306 25.5987 71.032 25.3804 69.9757C24.3945 69.9052 23.4086 69.9193 22.4297 70.0179",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9994 26.209C21.9572 27.4414 22.0346 28.6808 22.2389 29.8991C23.26 29.8287 24.2811 29.7583 25.2952 29.6879C25.2178 28.547 25.0487 27.4203 24.8023 26.3005C23.9361 26.4132 22.8656 26.2653 21.9924 26.209H21.9994Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5495 76.7363C22.5073 77.9687 22.4016 79.4687 22.6059 80.6871C23.627 80.6166 24.6481 80.6871 25.6622 80.6096C25.6622 79.5251 25.7186 78.011 25.5848 76.7363C24.7185 76.849 23.4157 76.7927 22.5425 76.7363H22.5495Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0139 33.5957C21.9294 34.8774 21.9717 36.1309 22.1407 37.4056C23.2463 37.3 24.352 37.2014 25.4647 37.0957C25.3731 35.9971 25.3168 34.7929 25.2182 33.6943C24.3238 33.7295 23.0773 33.6873 22.0139 33.5957Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3381 41.2991C22.3874 42.5244 22.2888 43.4611 22.3733 44.5738C23.2747 44.5738 24.3663 44.5738 25.2677 44.5738C25.3663 43.3906 25.3311 42.1935 25.1621 41.0174C24.2254 40.9751 23.2959 40.9329 22.3592 40.8906L22.3311 41.3061L22.3381 41.2991Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3449 84.4417C22.3942 85.667 22.2956 86.6036 22.3801 87.7163C23.2816 87.7163 24.3731 87.7163 25.2745 87.7163C25.3731 86.5332 25.3379 85.336 25.1689 84.16C24.2323 84.1177 23.3027 84.0755 22.3661 84.0332L22.3379 84.4487L22.3449 84.4417Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9932 47.8908L22.0213 51.5528C23.1129 51.4753 24.2397 51.6866 25.3312 51.6162C25.2678 50.5035 25.3171 49.0739 25.1974 47.9401C24.2537 47.8767 22.972 47.8274 22.0002 47.8908H21.9932Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1836 55.2444C22.247 56.4557 22.3244 57.667 22.416 58.8782C23.0639 58.8994 23.7118 58.9205 24.3597 58.9416C24.5146 58.9416 24.8526 58.9698 24.9653 58.8782C25.1202 58.7515 25.078 58.3501 25.0639 58.0473C25.0005 57.0543 24.9371 56.0613 24.8808 55.0684C24.0498 55.1177 23.0216 55.1881 22.1906 55.2374L22.1836 55.2444Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3594 62.334C22.3664 63.672 22.3805 64.8903 22.3875 66.2284C23.4016 66.2284 24.303 66.2425 25.3171 66.2495C25.3171 65.0734 25.3171 63.7495 25.289 62.4255C24.3101 62.4396 23.3312 62.4044 22.3594 62.334Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7326 19.7424L57.7538 23.2072C58.7749 23.1368 59.796 23.0664 60.8172 22.996C60.9439 21.9255 60.8946 20.8269 60.6763 19.7706C59.6904 19.7002 58.7045 19.7142 57.7256 19.8128",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7326 19.7424L57.7538 23.2072C58.7749 23.1368 59.796 23.0664 60.8172 22.996C60.9439 21.9255 60.8946 20.8269 60.6763 19.7706C59.6904 19.7002 58.7045 19.7142 57.7256 19.8128",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1692 70.4612L58.1903 73.926C59.2114 73.8555 60.2325 73.7851 61.2537 73.7147C61.3804 72.6443 61.3311 71.5457 61.1128 70.4893C60.1269 70.4189 59.141 70.433 58.1621 70.5316",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1692 70.4612L58.1903 73.926C59.2114 73.8555 60.2325 73.7851 61.2537 73.7147C61.3804 72.6443 61.3311 71.5457 61.1128 70.4893C60.1269 70.4189 59.141 70.433 58.1621 70.5316",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7328 26.7305C57.6906 27.9629 57.768 29.2023 57.9723 30.4206C58.9934 30.3502 60.0145 30.2798 61.0286 30.2094C60.9512 29.0685 60.7821 27.9417 60.5357 26.822C59.6695 26.9347 58.599 26.7868 57.7258 26.7305H57.7328Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2898 77.252C58.2475 78.4844 58.1419 79.9844 58.3461 81.2027C59.3672 81.1323 60.3884 81.2027 61.4024 81.1252C61.4024 80.0407 61.4588 78.5266 61.325 77.252C60.4588 77.3646 59.156 77.3083 58.2827 77.252H58.2898Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7464 34.1094C57.6618 35.3911 57.7041 36.6446 57.8731 37.9193C58.9788 37.8136 60.0844 37.715 61.1971 37.6094C61.1055 36.5108 61.0492 35.3066 60.9506 34.208C60.0562 34.2432 58.8097 34.2009 57.7464 34.1094Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0774 41.8147C58.1266 43.0401 58.0281 43.9767 58.1126 45.0894C59.014 45.0894 60.1055 45.0894 61.007 45.0894C61.1055 43.9063 61.0703 42.7091 60.9013 41.533C59.9647 41.4908 59.0351 41.4485 58.0985 41.4062L58.0703 41.8217L58.0774 41.8147Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0774 84.9553C58.1266 86.1807 58.0281 87.1173 58.1126 88.23C59.014 88.23 60.1055 88.23 61.007 88.23C61.1055 87.0469 61.0703 85.8497 60.9013 84.6736C59.9647 84.6314 59.0351 84.5891 58.0985 84.5469L58.0703 84.9624L58.0774 84.9553Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7256 48.4064L57.7538 52.0684C58.8453 51.991 59.9721 52.2022 61.0636 52.1318C61.0003 51.0191 61.0496 49.5895 60.9298 48.4557C59.9862 48.3923 58.7045 48.3431 57.7326 48.4064H57.7256Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.916 55.7639C57.9794 56.9752 58.0569 58.1865 58.1484 59.3978C58.7963 59.4189 59.4442 59.44 60.0921 59.4612C60.247 59.4612 60.585 59.4893 60.6977 59.3978C60.8527 59.271 60.8104 58.8696 60.7963 58.5668C60.7329 57.5738 60.6696 56.5809 60.6132 55.5879C59.7822 55.6372 58.754 55.7076 57.9231 55.7569L57.916 55.7639Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0918 62.8496C58.0988 64.1876 58.1129 65.406 58.12 66.744C59.1341 66.744 60.0355 66.7581 61.0496 66.7651C61.0496 65.5891 61.0496 64.2651 61.0214 62.9412C60.0425 62.9552 59.0636 62.92 58.0918 62.8496Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.176058,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11401_140044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.24,
    height: 79.2752,
    fill: "white",
    transform: "translate(3.37988 14.3633)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRecordReady);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/record-ready.8689a0c098a0687baf88948db5b8361f.svg";